//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.OrientXpressBuilder.js";
import "../no/SelectSplineList.js";
import "../no/SelectPointList.js";
import "../no/Features.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanMoveAlongCurve",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"EndContinuity",1,0],[0,"HasLinearTransition",1,0],[0,"InsertionMethod",1,0],[0,"MovementMethod",1,0],[0,"MovementPlane",1,"Plane",0],[0,"MovementVector",1,"Direction",0],[0,"Number",1,0],[1,"OrientExpress",0,"GeometricUtilities.OrientXpressBuilder",0],[1,"SelectCurves",0,"SelectSplineList",0],[1,"SpecifyPoints",0,"SelectPointList",0],[0,"StartContinuity",1,0],[0,"WCSOption",1,0]],[[["curve"],"AddCurve",{},1,0],[["curve"],"RemoveCurve",{},1,0],[["points","masterPoint"],"SetActivePoints",{},2,0],[[],"Deform",{},0,0],[["sourcePoint","destinationPoints"],"ApplyParameterValue",{},2,0],[["curve"],"DeleteAllPoints",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.CurveShapingBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.CurveShapingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.CurveShapingBuilder.InsertionMethodOptions = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints"});

SPLM.GeometricUtilities.CurveShapingBuilder.MovementMethodType = Object.freeze({
    "WCS" : "WCS", "View" : "View", "Vector" : "Vector", "Plane" : "Plane", "Normal" : "Normal"});

SPLM.GeometricUtilities.CurveShapingBuilder.WCSOptionType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "YZ" : "YZ", "XZ" : "XZ", "XY" : "XY"});

export default SPLM;